export enum InventoryTypeEnum {
    'certified' = 'CertifiedPreOwned',
    'new' = 'New',
    'used' = 'Used'
}

export enum DealTitle {
    'CertifiedPreOwned' = 'CPO',
    'New' = 'New',
    'Used' = 'Used',
    'All' = 'All'
}
